<template>
 <div class="prism-player" :id="'player-' + playerId"></div>
</template>

<script>
export default {
  props: {
    options: Object,
    src: String,
    cover: String,
    height: Number
  },
  computed: {
    playerId() {
      return Math.floor(Math.random()*10000+1)
    }
  },
  data() {
    return {
      player: null,
      aliplayOption:  {
        "source": '',
        "width": "100%",
        "height": "500px",
        "autoplay": false,
        "isLive": false,
        "rePlay": false,
        "playsinline": true,
        "preload": false,
        "controlBarVisibility": "click",
        "cover": this.cover,
        "useH5Prism": true,
        "skinLayout": [
          {
            "name": "bigPlayButton",
            "align": "blabs",
            "x": 30,
            "y": 80
          },
          {
            "name": "H5Loading",
            "align": "cc"
          },
          {
            "name": "errorDisplay",
            "align": "tlabs",
            "x": 0,
            "y": 0
          },
          {
            "name": "infoDisplay"
          },
          {
            "name": "tooltip",
            "align": "blabs",
            "x": 0,
            "y": 56
          },
          {
            "name": "thumbnail"
          }
        ]
      }
    }
  },
  mounted() {
    this.aliplayOption.height =  100*(document.documentElement.clientWidth/750)*this.height + 'px';
    this.aliplayOption.id = `player-${this.playerId}`;
    this.aliplayOption.source = this.src;
    if(this.options.isLive === 2) {
      this.aliplayOption.skinLayout.push(
          {
            "name": "controlBar",
            "align": "blabs",
            "x": 0,
            "y": 0,
            "children": [
              {
                "name": "progress",
                "align": "blabs",
                "x": 0,
                "y": 44
              },
              {
                "name": "playButton",
                "align": "tl",
                "x": 15,
                "y": 12
              },
              {
                "name": "timeDisplay",
                "align": "tl",
                "x": 10,
                "y": 7
              },
              {
                "name": "fullScreenButton",
                "align": "tr",
                "x": 10,
                "y": 12
              }
            ]
          });
      } else {
        this.aliplayOption.isLive = true;
        this.aliplayOption.skinLayout.push(
          {
            "name": "controlBar",
            "align": "blabs",
            "x": 0,
            "y": 0,
            "children": [
              {
                "name": "progress",
                "align": "blabs",
                "x": 0,
                "y": 44
              },
              {
                "name": "liveDisplay",
                "align": "tlabs",
                "x": 15,
                "y": 6
              },
              {
                "name": "fullScreenButton",
                "align": "tr",
                "x": 10,
                "y": 12
              }
            ]
          });
      }
    this.player = this.$createPlayer(
      this.aliplayOption
    );
    this.player.on('play',this.handlePlay);
    this.player.on('error',(e) => {
        var errorData = e.paramData;
        if(errorData.error_code === 4003 || errorData.error_code === 4004) {
          if(this.options.isLive === 2){
              document.getElementsByClassName('prism-error-content')[0].firstChild.innerHTML = '直播已结束';
          } else {
            document.getElementsByClassName('prism-error-content')[0].firstChild.innerHTML = '无直播信号';
          }          
        }
      });
    this.$emit('init',this.player)
  },
  methods: {
    loadByUrl(url) {
      if(this.player) {
        this.player.loadByUrl(url);
      }
    },
    handlePlay() {
      this.$emit('handlePlay',this.player, this.src)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.prism-player {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/AliPlayer.vue